module.exports = __webpack_public_path__ + "img/basic_skinwash_tube_202310.63252d68.jpg";